module.exports = __webpack_public_path__ + "static/img/roleInfo.7eee4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_4/roleInfo.png
// module id = 651f
// module chunks = 1